import * as React from "react";
import { homeprojects } from "@/data";
import { Link } from "gatsby";

// CSS
import "./Projects.css";

const Index = () => {
  return (
    <div className="bg-white py-5">
      <div className="container my-2 my-md-5">
        <div className="small-container">
          <div className="pb-5">
            <h2 className="text-left fs-1 mb-3 fw-bold">Recent Work</h2>
            <p className="text-left text-muted fs-4 col-lg-8 col-md-10">
              Explore a selection of my recent projects. Got an idea brewing?
              <br />
              Let's discuss and bring it to life together.
            </p>
          </div>
        </div>

        <div className="row">
          {homeprojects.map(({ title, url, imagePath, description }, i) => (
            <div className="col-lg-4 mb-4" key={i}>
              <a
                className="project-card d-flex justify-content-center align-items-center flex-column text-decoration-none"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                <div className="position-relative image mx-auto d-block">
                  <img
                    src={imagePath}
                    className="img-fluid w-100"
                    loading="lazy"
                    alt={title}
                  />
                </div>
                <div className="rounded text-center px-5 d-flex flex-column align-items-center justify-content-center">
                  <h2 className="fs-2 fw-bold text-black">{title}</h2>
                  <p className="mt-1 fs-4 text-black fw-normal truncate">
                    {description}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-5 text-end small-container">
          <Link className="btn-solid-lg rounded px-4 py-3 fs-5" to="/projects/">
            See More Work <i className="fa-solid fa-arrow-right ms-2" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
